
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.8 11.8v8.4h2.4v-8.4H2.8zM2 10a1 1 0 00-1 1v10a1 1 0 001 1h4a1 1 0 001-1V11a1 1 0 00-1-1H2zM10.6 3.8v16.4H13V3.8h-2.4zM9.8 2a1 1 0 00-1 1v18a1 1 0 001 1h4a1 1 0 001-1V3a1 1 0 00-1-1h-4zM18.4 7.8v12.4h2.4V7.8h-2.4zM17.6 6a1 1 0 00-1 1v14a1 1 0 001 1h4a1 1 0 001-1V7a1 1 0 00-1-1h-4z","fill":"#1D3C6F"}})])
          )
        }
      }
    